import { SegmentedControl, type SegmentedOption } from '@/components/shared/SegmentedControl';
import { type ThemePreference, useTheme } from '@/app/theme';
import { de } from '@/i18n/de';

const THEME_OPTIONS: readonly SegmentedOption<ThemePreference>[] = [
  { value: 'system', label: de.admin.themeSystem },
  { value: 'light', label: de.admin.themeLight },
  { value: 'dark', label: de.admin.themeDark },
];

/** Appearance preference — the one setting every user may change, admin or not. */
export function ThemeControl() {
  const { preference, setPreference } = useTheme();

  return (
    <SegmentedControl
      options={THEME_OPTIONS}
      value={preference}
      onChange={setPreference}
      size="roomy"
      aria-label={de.admin.appearance}
    />
  );
}
